<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>资讯</el-breadcrumb-item>
			<el-breadcrumb-item>资讯列表</el-breadcrumb-item>
		</el-breadcrumb>
		<el-button style="margin: 10px 0 20px;" type="success" @click="gotoAdd">+ 添加资讯文章</el-button>
		<el-card>
			<!-- 表格数据 -->
			<el-table :data="huodongList" border :strip="true">
				<el-table-column label="ID" width="70px" prop="id"></el-table-column><!-- type="index" -->
				<el-table-column label="标题" prop="title"></el-table-column>
				<el-table-column label="封面图">
					<template slot-scope="scope">
						<img :src="$imgTitle+scope.row.coverPicture" alt="" style="width: 200px;height: 119px;"/>
					</template>
				</el-table-column>
				<el-table-column label="所属分类" width="100px">
					<template slot-scope="scope">
						资讯
					</template>
				</el-table-column>
				<el-table-column label="权重" width="70px" prop="weights"></el-table-column>
				<el-table-column label="添加时间" prop="createTime">
					<template slot-scope="scope">{{scope.row.createTime | dataFormat }}</template>
				</el-table-column>
				<!-- <el-table-column label="商品数量" prop="goods_number" width="70px"></el-table-column>
			  <el-table-column label="创建时间" prop="add_time" width="140px">
			    <template slot-scope="scope">{{scope.row.add_time | dataFormat }}</template>
			  </el-table-column> -->
				<el-table-column label="操作">
					<!-- width="130px" -->
					<template slot-scope="scope">
						<!-- <el-button type="primary" icon="el-icon-edit" size="mini"></el-button>
			      <el-button
			        type="danger"
			        icon="el-icon-delete"
			        size="mini"
			        @click="removeById(scope.row.goods_id)"
			      ></el-button> -->
						<el-button type="primary" size="mini" @click="gotoEdit(scope.row.id)">编辑</el-button>
						<el-button type="danger" size="mini" @click="delHuodong(scope.row.id)">删除</el-button>
					</template> 
				</el-table-column>
			</el-table>
			
			<!-- 分页区域 -->
			<el-pagination
			  @size-change="handleSizeChange"
			  @current-change="handleCurrentChange"
			  :current-page="queryInfo.request.pageNo"
			  
			  :page-size="queryInfo.request.pageSize"
			  layout="total, prev, pager, next, jumper"
			  :total="total"
			  background
			></el-pagination>
			
		</el-card>
	</div>


</template>

<script>
	/* import HelloWorld from '@/components/HelloWorld.vue' */
	export default {
		name: 'Home',
		data() {
			return {
				queryInfo: {
					request: {
						type: 2, //活动 1 资讯 2
						pageNo: 1,
						pageSize: 5
					}
				},
				huodongList:[],
				total:0
			}
		},
		components: {

		},
		created() {
			
			this.getList()
		},
		methods: {
			async getList() {
				const res = await this.$http.post('/v1/official/manag/newsActivityListInfo', this.queryInfo) //查询活动资讯（分页）
				console.log(res)
				
				if(res.data.code == 0){
					this.huodongList = res.data.data.list;
					this.total = res.data.data.totalNum
				}else if(res.data.code == 102){
					this.$router.push({
						path:'/login'
					})
				}
			},
			handleSizeChange (newSize) {
			  this.queryInfo.request.pageSize = newSize
			  this.getList()
			},
			handleCurrentChange (newSize) {
			  this.queryInfo.request.pageNo = newSize
			  this.getList()
			},
			gotoAdd(){
				this.$router.push({
					path:"/addzixun"
				})
			},
			gotoEdit(id){
				this.$router.push({
				    path:"/editzixun",//这个path就是你在router/index.js里边配置的路径
				    query:{
				          id:id
				    }
				})
			},
			async delHuodong(id){
				console.log(id)
				const confirmResult = await this.$confirm(
				  '此操作将删除该文章, 是否继续?',
				  '提示',
				  {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				  }
				).catch(err => err)
				if (confirmResult !== 'confirm') {
				  return this.$message.info('已取消删除！')
				}//资讯/资讯删除接口 v1/official/manag/deleteActivityById  post接口 参数 int id
				var res = await this.$http.get('/v1/official/manag/deleteActivityById',{
							params:{
								id:id
							}
				})
				console.log(JSON.stringify(res))
				if(res.data.code == 0){
					this.$message.success('删除成功');
					this.getList();
				}else{
					this.$message.error(res.data.message)
				}
			}
		}
	}
</script>

<style lang="less" scoped>

</style>
